module.exports = __webpack_public_path__ + "img/d136376.png";